module.exports = __webpack_public_path__ + "static/media/carPhoto2.240960fb.jpg";